<template>
  <div class="skill">
    <div class="skill__wrapper">
      <div class="skill__value">
        <c-select
          v-model="item.value"
          type="select"
          :floating-label="skillLabel"
          :searchable="true"
          :items="options"
          :custom-options="config.param.custom"
          :required-mark="config.required"
          :clearable="true"
          :invalid="error && !!error.value"
          :error="error && error.value"
        />
      </div>

      <div class="skill__level">
        <c-select
          v-model="item.level"
          type="select"
          floating-label="Уровень"
          :searchable="true"
          :items="levelOptions"
          :custom-options="config.level.custom"
          :required-mark="config.required"
          :clearable="true"
          :invalid="error && !!error.level"
          :error="error && error.level"
        />
      </div>
      <div class="skill__remove">
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          size="iconic"
          icon="trash"
          class="lg"
          @click="$emit('remove')"
        />
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          label="Удалить"
          size="small"
          icon="trash"
          class="sm"
          @click="$emit('remove')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CSelect from "@/components/controls2/Select";
import CButton from "@/components/controls2/Button";

export default {
  components: { CSelect, CButton },
  props: ["item", "config", "skillLabel", "options", "levelOptions", "error"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.skill {
  border-bottom: 1px solid #dfe4ef;
  padding-bottom: 20px;
  margin-bottom: 20px;

  &__value,
  &__level {
    width: 100%;
    margin-bottom: 24px;
  }

  &__remove {
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .lg {
      display: none;
    }
  }

  @include bootstrapMd {
    border-bottom: none;
    padding-bottom: 0;

    &__wrapper {
      display: flex;
      margin-left: -15px;
      margin-right: -15px;
    }
    &__value,
    &__level {
      padding-left: 15px;
      padding-right: 15px;
      margin-bottom: 0px;

      width: calc(100% / 10 * 3);
    }

    &__remove {
      width: auto;
      padding-top: 20px;

      .lg {
        display: block;
      }
      .sm {
        display: none;
      }
    }
  }
}
</style>
